import { ExtensionBase } from "../extensionBase";
import { SwecoPropertyPanel } from "./swecoPropertyPanel";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions, viewerState } from "../../viewer";
import { UiUtils } from "../../common/uiUtils";
import * as SmartDrawings from "../../smartDrawings";

/**
 * An extension that replaces the default property panel ("Properties in Viewer toolbar) by a custom version.
 */
export class PropertyPanelExtension extends ExtensionBase {

    static extensionName = "PropertyPanelExtension";

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private panel: SwecoPropertyPanel;
    private title: string;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
        this.onModelRootLoaded = this.onModelRootLoaded.bind(this);
    }

    static registerExtension() {
        if (viewerOptions.tools.source !== "pdms" || (viewerOptions.tools.modelSettingsId != null && viewerOptions.tools.modelSettingsId.indexOf("pdms.") >= 0)) {
            super.registerExtension(PropertyPanelExtension.extensionName, PropertyPanelExtension);
        }
    }

    load(): boolean {
        console.log("PropertyPanelExtension is loaded!");
        this.panel = new SwecoPropertyPanel(this.viewer);
        // This replaces the default panel with ours.
        //this.viewer.setPropertyPanel(this.panel);
        this.viewer.addEventListener(SmartDrawings.SdEvents.SD_ROLE_CHANGE, this.onRoleChange);
        this.panel.addVisibilityListener((show) => { this.panel.resetProperties(show); });
        return super.load();
    };

    unload(): boolean {
        this.viewer.getToolbar(false).removeControl(this.subToolbar);
        this.viewer.removeEventListener(SmartDrawings.SdEvents.SD_ROLE_CHANGE, this.onRoleChange);
        return super.unload();
    };

    onToolbarCreated(): void {
        const propertyButton = UiUtils.createButton({
            id: "SmartDrawings.PropertyButton",
            tooltip: "Filtered properties",
            iconClass: "ion-md-list-box",
            onClick: () => {
                this.panel.setVisible(!this.panel.isVisible());
                if (this.title) {
                    this.panel.setTitle(this.title, null);
                }
            }
        });

        this.panel.addVisibilityListener(visible => {
            propertyButton.setState(visible ? Autodesk.Viewing.UI.Button.State.ACTIVE : Autodesk.Viewing.UI.Button.State.INACTIVE);
        });

        this.subToolbar = this.getControlGroup("SmartDrawings.Extensions");
        this.subToolbar.addControl(propertyButton);
    }

    onRoleChange = async (event) => {
        await this.setRules();
    }

    protected async onModelRootLoaded() {
        await this.setRules();
    }

    private async setRules() {
        const { data } = await ModelApi.getPropertyRules(viewerOptions.guid || viewerOptions.urn, viewerState.currentRole != null ? viewerState.currentRole.name : null);
        this.panel.setPropertyRules(data.criteria, data.title, data.titleSelector);
        this.title = data.title;
    }
}